export default function Cotton() {
  return (
    <section id="cotton" className="commodities">
      <div className="container">
        <div className="section-title">
          <h2>Cotton</h2>
          <p>
            <span>FMI</span> Cotton
          </p>
        </div>
        <div className="row">
          <div className="col-lg-4 d-none d-lg-inline">
            <img src="/assets/img/cover-images/cotton_cover.png" className="img-fluid" alt="Cotton Cover" style={{height: "100%"}}/>
          </div>
          <div className="col-lg-8 pt-4 pt-lg-0 content">
            {/* <h3 className="commodities-title">Sumary</h3> */}
            <div className="commodities-item">
              {/* <h4>Alice Barkley</h4> */}
              <p>
                <em>
                  Discover the world of cotton with Fund Marketing International (FMI).
                  We offer comprehensive indenting and brokerage services for cotton in Pakistan,
                  representing global commodity merchants and facilitating the sale of imported cotton.
                  We ensure a diverse range of quality products with imports from the USA, Brazil, Egypt, Australia, and West Africa.
                </em>
              </p>
              <p>
                <em>
                  Benefit from our strong partnerships with ginning factories nationwide and the Karachi Cotton Association (KCA).
                  Our team closely monitors both local and international cotton markets, providing invaluable insights into market dynamics.
                </em>
              </p>
            </div>

            {/* <h3 className="commodities-title">Education</h3> */}
            <div className="commodities-item">
              <p style={{color: "#FFB03B", fontWeight: "bold", textTransform: "capitalize"}}>
                Trust our trained agronomists for local cotton crop surveys and farm advisory services.
                Stay informed with our daily, weekly, and seasonal reports covering the latest developments
                in the cotton and textile sector, including:
              </p>
              <ul>
                <li>
                  <i className="icofont-rounded-right"></i>
                  Daily Pakistan Cotton Market Report
                </li>
                <li>
                  <i className="icofont-rounded-right"></i>
                  Weekly Cotton Export Report
                </li>
                <li>
                  <i className="icofont-rounded-right"></i>
                  Weekly Cotton Progress Report (in season)
                </li>
                <li>
                  <i className="icofont-rounded-right"></i>
                  Monthly Global Demand Supply Analysis
                </li>
              </ul>
            </div>
            <div className="commodities-item">
              {/* <h4>Bachelor of Fine Arts &amp; Graphic Design</h4>
              <h5>2010 - 2014</h5>
              <p><em>Rochester Institute of Technology, Rochester, NY</em></p> */}
              <p>
                Ready to explore opportunities in the cotton industry?
                {/* <br />
                <span style={{color: "#FFB03B", fontWeight: "bold", textTransform: "capitalize"}}>
                  Contact us
                </span> today for more information! */}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
